import React from "react";

/* eslint-disable max-len */
export default function SlideBackButton() {
    return (
        <svg version="1.1" id="레이어_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px"
            y="0px" viewBox="0 0 198.2 80.56" enableBackground="new 0 0 198.2 80.56" xmlSpace="preserve">
            <g>
                <g>
                    <path 
                        fill="#FFFFFF" d="M159.79,63.61H36.98c-14.38,0-26.04-11.66-26.04-26.04v0c0-14.38,11.66-26.04,26.04-26.04h122.8
			c14.38,0,26.04,11.66,26.04,26.04v0C185.83,51.95,174.17,63.61,159.79,63.61z"/>
                    <path fill="none" stroke="#6D6D6D" strokeWidth="3" strokeMiterlimit="10" d="M159.79,63.61H36.98
			c-14.38,0-26.04-11.66-26.04-26.04v0c0-14.38,11.66-26.04,26.04-26.04h122.8c14.38,0,26.04,11.66,26.04,26.04v0
			C185.83,51.95,174.17,63.61,159.79,63.61z"/>
                </g>
            </g>
            <path fill="#6D6D6D" d="M68.02,35.81c-4.97-4.15-10.57-4.96-12.82-5.15v-7.4L43.5,36.02l11.7,12.77v-7.08
	c0.78-0.16,2.7-0.18,4.15-0.12c8.64,0.39,14.59,6.52,16.65,8.88C75.77,48.69,74.6,41.29,68.02,35.81z"/>
            <g>
                <path fill="#6D6D6D" d="M89.01,26.93h5.85c2.54,0,4.47,0.37,5.78,1.12c1.32,0.75,1.97,2.04,1.97,3.86c0,1.16-0.31,2.13-0.94,2.91
		c-0.63,0.78-1.52,1.28-2.67,1.48v0.14c0.78,0.15,1.5,0.4,2.14,0.74c0.64,0.35,1.15,0.84,1.53,1.48c0.37,0.64,0.56,1.49,0.56,2.53
		c0,1.83-0.63,3.24-1.9,4.23c-1.27,0.99-2.99,1.48-5.15,1.48h-7.17V26.93z M92.04,35.27h3.33c1.57,0,2.65-0.25,3.23-0.76
		s0.88-1.25,0.88-2.24s-0.36-1.7-1.08-2.14s-1.84-0.66-3.37-0.66h-3V35.27z M92.04,37.74v6.66h3.67c1.61,0,2.73-0.32,3.37-0.95
		c0.64-0.63,0.97-1.47,0.97-2.52c0-0.95-0.33-1.72-0.99-2.31c-0.66-0.59-1.84-0.88-3.54-0.88H92.04z"/>
                <path fill="#6D6D6D" d="M112.9,31.55c1.89,0,3.3,0.42,4.24,1.25c0.94,0.83,1.41,2.13,1.41,3.91v10.22h-2.1l-0.59-2.1h-0.11
		c-0.65,0.82-1.34,1.42-2.06,1.81c-0.72,0.38-1.71,0.57-2.98,0.57c-1.36,0-2.49-0.37-3.39-1.11c-0.9-0.74-1.34-1.89-1.34-3.46
		c0-1.55,0.58-2.72,1.75-3.51c1.17-0.79,2.94-1.23,5.33-1.3l2.58-0.08V36.9c0-1.1-0.25-1.88-0.76-2.34
		c-0.5-0.46-1.21-0.69-2.13-0.69c-0.77,0-1.5,0.11-2.21,0.34c-0.71,0.22-1.39,0.5-2.04,0.81l-0.95-2.16
		c0.71-0.37,1.53-0.69,2.45-0.94C110.92,31.67,111.89,31.55,112.9,31.55z M115.61,39.67l-2.02,0.06c-1.72,0.08-2.91,0.36-3.57,0.87
		c-0.66,0.5-0.99,1.2-0.99,2.07c0,0.78,0.23,1.35,0.7,1.71s1.07,0.53,1.82,0.53c1.16,0,2.12-0.33,2.9-0.98
		c0.77-0.65,1.16-1.63,1.16-2.94V39.67z"/>
                <path fill="#6D6D6D" d="M129.19,47.2c-2.09,0-3.77-0.62-5.04-1.86c-1.27-1.24-1.9-3.2-1.9-5.87c0-1.87,0.31-3.38,0.92-4.54
		c0.62-1.16,1.46-2.01,2.55-2.56s2.31-0.83,3.7-0.83c0.84,0,1.63,0.08,2.37,0.25c0.74,0.17,1.35,0.37,1.83,0.62l-0.9,2.41
		c-0.52-0.19-1.07-0.36-1.65-0.52c-0.58-0.16-1.14-0.24-1.68-0.24c-2.73,0-4.09,1.79-4.09,5.38c0,1.72,0.34,3.02,1.01,3.92
		c0.67,0.9,1.66,1.34,2.97,1.34c0.82,0,1.56-0.09,2.21-0.28c0.65-0.19,1.25-0.43,1.79-0.73v2.58c-0.54,0.32-1.13,0.55-1.76,0.7
		C130.88,47.13,130.11,47.2,129.19,47.2z"/>
                <path fill="#6D6D6D" d="M139.77,25.64v10.64c0,0.37-0.02,0.82-0.06,1.34c-0.04,0.52-0.07,0.99-0.08,1.4h0.08
		c0.21-0.28,0.49-0.65,0.85-1.11c0.36-0.46,0.69-0.83,0.97-1.13l4.62-4.96h3.44l-6.08,6.47l6.47,8.62h-3.5l-4.98-6.75l-1.74,1.46
		v5.29h-2.94V25.64H139.77z"/>
            </g>
        </svg>
    );
}
